export default __webpack_public_path__ + "static/Plots0002-88979b8a7571721422350f96150ba7b5.jpg";